<template>
  <div class="container-item">
    <div class="item">
      {{ $t('apps.payroll.label.name') }}
    </div>
    <div class="item wages">
      {{ $t('apps.payroll.label.wageamount') }}
    </div>
    <div
      v-for="(item, index) in insertColumns"
      :key="index"
      class="item insert-column"
    >
      {{ item.name }}
    </div>
    <div class="item net">
      {{ $t('apps.payroll.label.net') }}
    </div>
    <div
      v-if="!disabled"
      class="item delete"/>
  </div>
</template>

<script>
import { cloneDeep } from 'lodash'

export default {
  props: {
    conditions: Array,
    conditionIds: Array,
    disabled: Boolean,
  },

  computed: {
    insertColumns () {
      const ids = cloneDeep(this.conditionIds)
      ids.sort()
      return ids.map((id) => {
        const item = this.conditions.find((cond) => cond.conditionId === id)
        return {
          ...item,
        }
      })
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/components/base/BasePaySlipEmployeeHead.vue